import React, { useEffect } from 'react';
import { useAppStore } from '../store';
import SearchForm from '../components/search/SearchForm';
import ProjectGrid from '../components/project/ProjectGrid';

const SearchPage: React.FC = () => {
  const {
    searchResults,
    searchLoading,
    error,
    clearError,
    cancelSearch
  } = useAppStore();

  // 处理错误显示
  useEffect(() => {
    if (error) {
      const shouldShowError =
        !error.includes('加载收藏失败') &&
        !error.includes('请先登录') &&
        !error.includes('LOGIN_REQUIRED') &&
        !error.includes('用户不存') &&
        !error.includes('获取用户信息失败') &&
        !error.includes('Token验证失败');

      if (shouldShowError) {
        console.warn('Search page error:', error);
        const timer = setTimeout(() => {
          clearError();
        }, 5000);
        return () => clearTimeout(timer);
      } else {
        console.log('过滤掉初始化错误:', error);
        clearError();
      }
    }
  }, [error, clearError]);

  const handleCancelSearch = () => {
    cancelSearch();
    console.log('搜索已取消');
  };

  return (
    <div className="search-page">
      <div className="search-page-header">
        <div className="search-header-content">
          <h1>
            <i className="fab fa-github" />
            GitHub 项目搜索
          </h1>
          <p>发现最新最热的开源项目，探索技术前沿</p>
        </div>
      </div>

      <div className="search-page-content">
        {/* 搜索表单 */}
        <div className="search-form-section">
          <div className="container">
            <SearchForm />
          </div>
        </div>

        {/* 加载状态遮罩（只在首次搜索或无结果时全屏显示） */}
        {searchLoading && searchResults.length === 0 && (
          <div className="loading-container">
            <div className="loading-card">
              <button
                className="loading-close-btn"
                title="取消搜索"
                onClick={handleCancelSearch}
              >
                <i className="fas fa-times" />
              </button>

              <div className="progress-container">
                <div className="progress-bar">
                  <div className="progress-fill" />
                </div>
                <div className="progress-text">
                  <span className="progress-percent">0%</span>
                  <span className="progress-stage">准备搜索...</span>
                </div>
              </div>

              <div className="loading-animation">
                <div className="loading-spinner">
                  <div className="spinner-ring" />
                  <div className="spinner-ring" />
                  <div className="spinner-ring" />
                </div>
              </div>

              <div className="loading-messages">
                <h4>正在搜索项目...</h4>
                <p>正在连接 GitHub API...</p>
                <div className="loading-tips">
                  <div className="tip-item active">
                    <i className="fas fa-lightbulb" />
                    <span>小贴士：使用快捷标签可以快速搜索热门项目</span>
                  </div>
                  <div className="tip-item">
                    <i className="fas fa-star" />
                    <span>项目按 Star 数排序，帮您找到最受欢迎的项目</span>
                  </div>
                  <div className="tip-item">
                    <i className="fas fa-history" />
                    <span>搜索历史会自动保存，方便您重复查询</span>
                  </div>
                  <div className="tip-item">
                    <i className="fas fa-filter" />
                    <span>可以按编程语言过滤，精确找到您需要的项目</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* 错误提示 */}
        {error && !error.includes('加载收藏失败') && !error.includes('请先登录') && (
          <div className="alert alert-danger" role="alert">
            <i className="fas fa-exclamation-triangle" />
            <span>{error}</span>
          </div>
        )}

        {/* 项目列表 */}
        <div className="search-results-section">
          {!searchLoading && searchResults.length > 0 && (
            <ProjectGrid projects={searchResults} />
          )}

          {!searchLoading && searchResults.length === 0 && (
            <div className="no-results">
              <div className="no-results-icon">
                <i className="fas fa-search" />
              </div>
              <h3>暂无搜索结果</h3>
              <p>尝试调整搜索条件或使用不同的关键词</p>
              <div className="search-suggestions">
                <h4>搜索建议：</h4>
                <ul>
                  <li>使用更通用的关键词</li>
                  <li>检查拼写是否正确</li>
                  <li>尝试不同的编程语言筛选</li>
                  <li>调整时间范围</li>
                </ul>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SearchPage;
